import Vue from 'vue';
import billingService from '../../../../services/user-billing';
import mixin from "../../../../mixins/mixin";
import accountService from "../../../../services/account";

export default {
  data() {
    return {
      loading: false,
      billing: {
        card_last_digits: ""
      },
      submitButtonDisabled: false,
      stripeToken: '',
      user: {},
      deleteCard: false,
      invoices: {},
      changePaymentCard: false,
    };
  },
  components: {
    VLoading : require('components/loading/loading.vue'),
  },
  mixins: [mixin],
  async mounted() {
    let vm = this;
    vm.loading = true;
    $('#card-expiration').on('input', function() {
      let val = String($(this).val());
      val = val.replace(/[^0-9\/ ]/g, '');

      if (val.length == 1 && parseInt(val) > 1 ||
        val.length == 2 && val.charAt(1) == '/' ||
        val.length == 2 && val.charAt(1) == ' ') {
        val = '0' + parseInt(val) + ' / ';
      } else if (val.length == 2 && parseInt(val) == 1 ) {
        val = '01' + ' / ';
      } else if (val.length == 2 && parseInt(val) == 0 ) {
        val = '0';
      } else if (val.length == 2 && parseInt(val) <= 12 ) {
        val = val + ' / ';
      } else if (val.length == 2 && parseInt(val) > 12 ) {
        val = val.substring(val.length-2, val.length-1);
      } else if (val.length == 4) {
        val = val.substring(0, 1);
      }  else if (val.length > 4) {
        var before = val.substring(0, 5);
        var after = val.substring(5, val.length);
        after = after.replace(/[\/ ]/g, '');
        val = before + after;
      }
      $(this).val(val);
    });

    accountService.getStripeKey(this);
    vm.loading = false;
  },
  watch: {

  },
  methods: {
    storeCard() {
      let vm = this;
      vm.openModal('#change-card-modal');
    },
    async submitCheckout(changePaymentCard) {
      this.changePaymentCard = changePaymentCard;
      this.submitButtonDisabled = true;
      let $form = $('#billingInfoForm');
      // disabled submit button
      let exp = $("#card-expiration").val();
      let e = exp.split("/");
      $("#exp_month").data("data-stripe",  "exp_month");
      $("#exp_month").val(e[0].replace(" ",''));
      $("#exp_year").data("data-stripe",  "exp_year");
      $("#exp_year").val(e[1].replace(" ",''));

      // Request token from Stripe
      await Stripe.card.createToken($form, this.stripeResponseHandler);
    },
    async stripeResponseHandler(status, response){
      let vm = this;
      if (response.error) { // Problem!
        let text = "";
        if(response.error.message.match(/A network error has occurred/)){
          text = vm.$t('payments.permalink.errors.network_error');
        }else if(response.error.message.match(/Your card number is incorrect/)){
          text = vm.$t('payments.permalink.errors.card_number_incorrect');
        }else if(response.error.message.match(/Expired API Key/)){
          text = vm.$t('payments.permalink.errors.expired_api_key');
        }else if(response.error.message.match(/Your card's expiration year is invalid/)){
          text = vm.$t('payments.permalink.errors.exp_year');
        }else {
          text = vm.$t('payments.permalink.errors.contact_support');
        }

        // showing error message
        toastr.error(text);
        vm.submitButtonDisabled = false;

      } else {
        vm.stripeToken = response.id;
        let data = {
          'card_number': $("#card-number").val(),
          'card_brand': response.card.brand,
          'stripe_token': vm.stripeToken
        };

        await billingService.changeCard(vm, data);

        vm.submitButtonDisabled = false;
      }
    },
    changeCard() {
      let vm = this;
      vm.deleteCard = false;
      vm.openModal('#change-card-modal');
    },
    async deleteOldCard() {
     this.deleteCard = true;
     this.submitCheckout();
    },
  },
  computed: {
    account: function () {
      return this.$store.state.account;
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/account/credit-card/index/index.js